import {patchJSONPromise, postJSONPromise} from 'util/Net';

const API_BASE = '/1/api/studyables';

// Keep in sync with STUDYABLE_STUDY_ASSOCIATIONS_SPEC_FIELDS
// in /src/benchling/studies/studyable/network/rest/studyable_rest_specs.py
export interface StudyAssociation {
  // The api id of the study
  studyId: string;
  // When true, items created in the studyable will be associated with the study
  isAutoLinking?: boolean;
}

interface StudyableUpdateParams {
  // Map of studyable ids to their study associations
  studyableAssociations: {[studyableId: string]: Array<StudyAssociation>};
}
interface UpdateStudyablesResponse {}

export function updateStudyables(data: StudyableUpdateParams): Promise<UpdateStudyablesResponse> {
  return patchJSONPromise({url: API_BASE, data});
}

interface StudyableCreateParams {
  // Map of studyable ids to the list of study ids they should be associated with
  studyables: {[studyableId: string]: Array<string>};
}
interface CreateStudyablesResponse {}

export function addStudyables(data: StudyableCreateParams): Promise<CreateStudyablesResponse> {
  return postJSONPromise({url: API_BASE, data});
}
